<template>
  <!-- END Side Overlay -->
  <header id="page-header">
    <!-- Header Content -->
    <div class="content-header">
      <!-- Left Section -->
      <div class="d-flex align-items-center">
        <router-link class="btn btn-sm btn-dual mr-2" to="/">
          <i class="si si-home"></i>
        </router-link>
        <button type="button" class="btn btn-sm btn-dual mr-2 d-none" data-toggle="modal" data-target="#one-modal-apps">
          <i class="si si-grid"></i>
        </button>
      </div>
      <!-- END Left Section -->
      <!-- Right Section -->
      <div class="d-flex align-items-center">
        <div class="d-none d-sm-table-cell align-items-center">
          <i class="fa fa-object-group text-gray ml-2"></i><strong>{{ Object.keys(library.plantBatches).length }}</strong>
          <i class="far fa-lightbulb fa-rotate-180 text-info ml-2"></i><strong>{{ Object.keys(library.vegetativePlants).length }}</strong>
          <i class="fa fa-cannabis text-success ml-2"></i><strong>{{ Object.keys(library.floweringPlants).length }}</strong>
          <i class="fa fa-cut text-primary ml-2"></i><strong>{{ Object.keys(library.harvests).length }}</strong>
          <i class="fa fa-box-open text-danger  ml-2"></i><strong>{{ Object.keys(library.packages).length }}</strong>
        </div>
        <!-- User Dropdown -->
        <div class="dropdown d-inline-block ml-3">
          <button type="button" v-if="!showLoader" class="btn btn-sm btn-dual" id="page-header-user-dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img class="rounded" src="/static/media/avatars/avatar10.jpg" alt="Header Avatar" style="width: 18px;">
            <span class="d-none d-sm-inline-block ml-1">{{ library.user.firstName }} {{ library.user.lastName }}</span>
            <i class="fa fa-fw fa-angle-down d-none d-sm-inline-block"></i>
          </button>
          <span class="modal-loader" v-if="showLoader">
            <hash-loader class="custom-class" color="#495054" loading="loading" size="18" sizeUnit="px"></hash-loader>
          </span>
          <div class="dropdown-menu dropdown-menu-right p-0 border-0 font-size-sm" aria-labelledby="page-header-user-dropdown">
            <div class="p-3 text-center bg-primary">
              <img class="img-avatar img-avatar48 img-avatar-thumb" src="/static/media/avatars/avatar10.jpg" alt="">
            </div>
            <div class="p-2">
              <h5 class="dropdown-header text-uppercase">User Options</h5>
              <router-link class="dropdown-item d-flex align-items-center justify-content-between" to="/profile">
                <span>Profile</span>
                <span>
                  <i class="si si-user ml-1"></i>
                </span>
              </router-link>
              <router-link to="/settings" class="dropdown-item d-flex align-items-center justify-content-between">
                <span>Settings</span>
                <i class="si si-settings"></i>
              </router-link>
              <div role="separator" class="dropdown-divider"></div>
              <h5 class="dropdown-header text-uppercase">Actions</h5>
              <a class="dropdown-item d-flex align-items-center justify-content-between" href="#" @click.prevent="logout()" >
                <span>Log Out</span>
                <i class="si si-logout ml-1"></i>
              </a>
            </div>
          </div>
        </div>
        <!-- END User Dropdown -->
        <!-- Notifications Dropdown -->
        <div class="dropdown d-inline-block ml-2">
          <button type="button" class="btn btn-sm btn-dual" id="page-header-notifications-dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="updateSystemNotificationStatus()">
          <i class="si si-bell"></i>
            <span class="badge badge-primary badge-pill" v-if="library.recentNotificationCount != 0">{{ library.recentNotificationCount }}</span>
          </button>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 border-0 font-size-sm" aria-labelledby="page-header-notifications-dropdown">
            <div class="p-2 bg-warning text-center">
              <h5 class="dropdown-header text-uppercase text-white"><i class="fa fa-broadcast-tower"></i> Reminders</h5>
            </div>
            <ul class="nav-items mb-0">
              <li v-for="(notification, index) in library.recentNotifications" :key="index">
                <a class="text-dark media py-2" href="javascript:void(0)">
                  <div class="mr-2 ml-3">
                    <i class="fa fa-fw fa-fill-drip text-info"></i>
                  </div>
                  <div class="media-body pr-2">
                    <div class="font-w600">{{ notification.name }}</div>
                    <small class="text-muted">{{ notification.addedTimeAgo }} ago</small>
                  </div>
                </a>
              </li>
              <li class="text-dark media py-2" v-if="!library.recentNotifications.length">
                <div class="mr-2 ml-3"></div>
                <div class="media-body pr-2">
                  <div class="font-w600">No Reminders Found</div>
                </div>
              </li>
            </ul>
            <div class="p-2 border-top">
              <router-link to="/reminder" class="btn btn-sm btn-light text-center">
                <i class="fa fa-fw fa-clock"></i> History
              </router-link>
              <a class="btn btn-sm btn-success text-center fa-pull-right" href="#add_reminder" data-toggle="modal">
              <i class="fa fa-plus"></i> Add New
              </a>
            </div>
          </div>
        </div>
        <div class="dropdown d-inline-block ml-2">
          <button type="button" data-toggle="modal" data-target="#feedback" title="Leave feedback" class="btn btn-sm btn-dual">
            <i class="fas fa-lightbulb text-warning"></i>
          </button>
        </div>
        <!-- END Notifications Dropdown -->
        <!-- Toggle Side Overlay -->
        <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
        <!--            <button type="button" class="btn btn-sm btn-dual ml-2" data-toggle="layout" data-action="side_overlay_toggle">
          <i class="fa fa-fw fa-list-ul fa-flip-horizontal"></i>
          </button>-->
        <!-- END Toggle Side Overlay -->
      </div>
      <!-- END Right Section -->
    </div>
    <!-- END Header Content -->
    <!-- Header Search -->
    <div id="page-header-search" class="overlay-header bg-white">
      <div class="content-header">
        <form class="w-100" action="#" method="POST">
          <div class="input-group input-group-sm">
            <div class="input-group-prepend">
              <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
              <button type="button" class="btn btn-danger" data-toggle="layout" data-action="header_search_off">
              <i class="fa fa-fw fa-times-circle"></i>
              </button>
            </div>
            <input type="text" class="form-control" placeholder="Search or hit ESC.." id="page-header-search-input" name="page-header-search-input">
          </div>
        </form>
      </div>
    </div>
    <!-- END Header Search -->
    <!-- Header Loader -->
    <!-- Please check out the Loaders page under Components category to see examples of showing/hiding it -->
    <div id="page-header-loader" class="overlay-header bg-white">
      <div class="content-header">
        <div class="w-100 text-center">
          <i class="fa fa-fw fa-circle-notch fa-spin"></i>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions} from 'vuex';
import { VueSpinners } from '@saeris/vue-spinners';
import { HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
Vue.use(VueSpinners);

export default {
  name: 'PageHeader',
  data() {
    return {
      showLoader: false,
      recentNotifications: [],
      recentNotificationCount: 0
    };
  },
  components: {
    HashLoader
  },
  computed: {
    ...mapState({
      library: state => state.library
    })
  },
  mounted() {
    let vm = this;
    vm.showLoader = true;
    vm.$store.dispatch('library/getAllUserData').then(() => {
      vm.showLoader = false;
    });
    helper.sendPostRequest('/strains/active', {}).then((data) => {
      if (data.status === 'error' && data.message !== '') {
        helper.showErrorModal(data);
      } else {
        setTimeout(() => {
          helper.loadSiteData();
        }, 2500);
      }
    });
    vm.getRecentNotificationList();
    vm.getRecentNotificationCount();
  },
  methods: {
    ...mapActions('library', ['clearData', 'getRecentNotificationList', 'getRecentNotificationCount']),
    logout() {
      let vm = this;
      helper.sendPostRequest('/logout', {}).then((data) => {
        if (data.status === 'success') {
          vm.clearData();
          helper.finishLogout();
        }
      });
    },
    updateSystemNotificationStatus() {
      if (this.$store.state.library.recentNotificationCount) {
        let vm = this;
        helper.sendRequest('/todo/update', { 'updateSysNotification': 1 }).then(() => {
          vm.getRecentNotificationList();
          vm.getRecentNotificationCount();
        });
      }
    }
  }
};
</script>

<style>
.dropdown-menu.dropdown-menu-right .badge {
  position: relative;
  top: -2px;
}
.custom-class.css-1a4tlxd {
  position: initial !important;
  transform: none !important;
}
</style>



// WEBPACK FOOTER //
// source/components/PageHeader.vue